export var InvoicesStatus;
(function (InvoicesStatus) {
    InvoicesStatus[InvoicesStatus["Initial"] = 0] = "Initial";
    InvoicesStatus[InvoicesStatus["PreparingInvoice"] = 1] = "PreparingInvoice";
    InvoicesStatus[InvoicesStatus["PrepareInvoiceSuccess"] = 2] = "PrepareInvoiceSuccess";
    InvoicesStatus[InvoicesStatus["CalculatingInvoice"] = 3] = "CalculatingInvoice";
    InvoicesStatus[InvoicesStatus["CalculateInvoiceSuccess"] = 4] = "CalculateInvoiceSuccess";
    InvoicesStatus[InvoicesStatus["SavingInvoice"] = 5] = "SavingInvoice";
    InvoicesStatus[InvoicesStatus["SaveInvoiceSuccess"] = 6] = "SaveInvoiceSuccess";
    InvoicesStatus[InvoicesStatus["GettingInvoice"] = 7] = "GettingInvoice";
    InvoicesStatus[InvoicesStatus["GetInvoiceSuccess"] = 8] = "GetInvoiceSuccess";
    InvoicesStatus[InvoicesStatus["UpdatingInvoice"] = 9] = "UpdatingInvoice";
    InvoicesStatus[InvoicesStatus["UpdateInvoiceSuccess"] = 10] = "UpdateInvoiceSuccess";
    InvoicesStatus[InvoicesStatus["FetchingTips"] = 11] = "FetchingTips";
    InvoicesStatus[InvoicesStatus["FetchTipsSuccess"] = 12] = "FetchTipsSuccess";
    InvoicesStatus[InvoicesStatus["SavingTip"] = 13] = "SavingTip";
    InvoicesStatus[InvoicesStatus["SaveTipSuccess"] = 14] = "SaveTipSuccess";
    InvoicesStatus[InvoicesStatus["CreatingDepositInvoice"] = 15] = "CreatingDepositInvoice";
    InvoicesStatus[InvoicesStatus["CreateDepositInvoiceSuccess"] = 16] = "CreateDepositInvoiceSuccess";
    InvoicesStatus[InvoicesStatus["FetchingAdminInvoices"] = 17] = "FetchingAdminInvoices";
    InvoicesStatus[InvoicesStatus["FetchAdminInvoicesSuccess"] = 18] = "FetchAdminInvoicesSuccess";
    InvoicesStatus[InvoicesStatus["Error"] = 19] = "Error";
})(InvoicesStatus || (InvoicesStatus = {}));
